import * as React from 'react';
import MediaQuery from 'react-responsive';
import { TABLET_MIN_WIDTH } from '../../../../../../utils';
import Dropdown from '../../../../../../Dropdown';
import SlideBottom from '../../../../../../SlideBottom/';

interface Props {
	isOpen: boolean;
	onClose: () => void;
}

const DropdownAdapter: React.FC<Props> = props => {
	return (
		<>
			<MediaQuery minWidth={TABLET_MIN_WIDTH}>
				<Dropdown isOpen={props.isOpen} onClose={props.onClose}>
					{props.children}
				</Dropdown>
			</MediaQuery>

			<MediaQuery maxWidth={TABLET_MIN_WIDTH}>
				<SlideBottom isOpen={props.isOpen} onClose={props.onClose}>
					{props.children}
				</SlideBottom>
			</MediaQuery>
		</>
	);
};
export default DropdownAdapter;
